/**
 * AuthorCard — Editorial-attribution card shown at the top of articles.
 *
 * Wraps FounderCard (compact variant) so every article opens with the same
 * founder presence used across the site. A small "Follow our wonder" link
 * to /undring stays for in-article discovery of the rest of the catalogue.
 */

import { Link } from 'react-router-dom';
import { FounderCard } from '../landing/FounderCard';

export interface AuthorCardProps {
  lang: 'no' | 'en';
}

export function AuthorCard({ lang }: AuthorCardProps) {
  const followLabel = lang === 'no' ? 'Følg vår undring' : 'Follow our wonder';

  return (
    <div className="max-w-3xl mx-auto">
      <FounderCard lang={lang} variant="compact" />
      <div className="px-1 -mt-4 mb-2">
        <Link
          to="/undring"
          className="inline-block font-display font-medium text-sm text-teal hover:text-teal-dark transition-colors"
        >
          {followLabel} →
        </Link>
      </div>
    </div>
  );
}

export default AuthorCard;
